import { HttpRequestBody } from '../interfaces';
import streamToBlob from './streamToBlob';

const isStream = (obj: unknown): obj is ReadableStream => {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof (obj as Record<string, unknown>).pipe === 'function'
  );
};

const toHttpRequestBodyMaybe = async (
  body?: HttpRequestBody | ReadableStream<Uint8Array> | null
): Promise<HttpRequestBody | undefined> => {
  if (!body) {
    return Promise.resolve(undefined);
  }
  if (isStream(body)) {
    return streamToBlob(body);
  } else {
    return Promise.resolve(body);
  }
};
export default toHttpRequestBodyMaybe;
